import { Link } from "react-router-dom";
import heroBanner from "../../assets/images/8-hour-idi.png";
import ShellCard from "../../components/ShellCard";

const EightHourIDI = () => {
  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">8 Hour I.D.I. Course</h1>
              <p className="banner-subheading">State of Florida Certified</p>
            </div>
          </div>
        </div>
      </section>
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-12">
            <ShellCard>
              <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>
                Course Details
              </h3>
              <div className="course-body">
                <div className="mb-4">
                  <p className="text-white mt-0 lead-paragraph fs-5">
                    The 8 hour Intermediate Driver Improvement Course may be
                    taken by{" "}
                    <a
                      href="/online-traffic-school"
                      className="text-warning fw-bold text-decoration-none"
                    >
                      Internet
                    </a>
                    , or in a{" "}
                    <a
                      href="/classroom-traffic-school"
                      className="text-warning fw-bold text-decoration-none"
                    >
                      Live class
                    </a>{" "}
                    format.
                  </p>
                </div>

                <div className="row mb-4" style={{ gap: "16px" }}>
                  <div className="col-md px-0">
                    <div
                      className="h-100 p-3"
                      style={{
                        backgroundColor: "#252525",
                        border: "1px solid var(--metro-yellow)",
                        borderRadius: "8px",
                      }}
                    >
                      <p className="text-white mb-0">
                        This course is similar in context to the 4 hour, but is
                        a bit more detailed in addressing driver safety.
                      </p>
                    </div>
                  </div>

                  <div className="col-md px-0">
                    <div
                      className="h-100 p-3"
                      style={{
                        backgroundColor: "#252525",
                        border: "1px solid var(--metro-yellow)",
                        borderRadius: "8px",
                      }}
                    >
                      <p className="text-white mb-0">
                        This Course may also, and often is, taken due to a judge
                        ordering the completion of an 8 hour program for a
                        particular citation.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <p className="text-white mb-0">
                    This course may be taken in place of the 4 hour course in
                    SOME COUNTIES if you have already taken a 4 hour course
                    within the past twelve months, in order to avoid points for
                    the second traffic violation. Please see the list of County
                    Clerks of Court, and contact the clerk of court in the
                    county in which the ticket was received to verify if they
                    accept the 8 hour Program. You are guaranteed to pass – Free
                    retakes.
                  </p>
                </div>

                <div className="mb-5">
                  <p className="text-white mb-0">
                    In either case, Election or Judgment, it may be completed by
                    Internet or a live class.
                  </p>
                </div>

                <div className="mt-5 text-center">
                  <Link
                    to="https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=MzIwMA=="
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-primary text-decoration-none"
                    style={{
                      backgroundColor: "var(--metro-yellow)",
                      border: "none",
                    }}
                  >
                    <i className="fas fa-user-plus me-2"></i>
                    REGISTER NOW
                  </Link>
                </div>

                <div className="my-5 container contact-call">
                  <p className="mt-3 fw-bold mb-0">
                    Call{" "}
                    <a href="tel:1-888-41-METRO" className="contact-phone">
                      1-888-41-METRO
                    </a>{" "}
                    for more information.
                  </p>
                </div>
              </div>
            </ShellCard>
          </div>
        </div>
      </div>
    </>
  );
};

export default EightHourIDI;
